import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'
import { getMatchPlayers } from '@shared/libs/match-detail'
import useWindowSize from '@shared/hooks/windowSize'

const EndOverRC = ({ data, id, inning, isFirst, index }) => {
  const players = getMatchPlayers()
  const [width] = useWindowSize()
  const totalRuns = data?.aOverScores?.reduce((acc, ball) => {
    if (ball?.match(/^[0-9]$/)) {
      acc += Number(ball)
    } else if (ball?.indexOf('wd') > 0 || ball?.indexOf('nb') > 0 || ball?.indexOf('Wd') > 0 || ball?.indexOf('Nb') > 0) {
      acc += 1
    }
    return acc
  }, 0)

  const oBowler = players[data?.aBowlers?.[0]?.iBowlerId] || data?.aBowlers?.[0]?.oBowler

  return (
    <>
      <div className={`${styles.over} d-flex flex-wrap flex-xl-nowrap align-items-xl-center ${!isFirst && styles.brdtp}`} id={id}>
        <div className={width > 767 ? styles.dContents : `d-flex w-100 ${styles.rowMweb}`}>
          <div className={`${styles.info} text-center`}>
            <h3 className={`${styles.heading} mb-0 small-head`}> {data?.sOver}</h3>
            <div className={styles.orangeText}>End of Over</div>
          </div>
          {width > 767 && (
            <>
              <div className={styles.divider}></div>
              <div className={`${styles.info} text-center`}>
                <p className={`${styles.heading} mb-0 big-text font-bold`}>
                  {data?.aOverScores?.map((ball, index) => {
                    return <span className={styles.run} key={index}>{ball}</span>
                  })}
                </p>
                <div className={styles.orangeText}>Total runs scored: {totalRuns}</div>
              </div>
            </>
          )}
          {index !== inning?.length - 1 && (
            <div className={styles.divider}></div>
          )}
          <div className={`${styles.info} ${width > 767 && 'text-center'} `}>
            <p className={`${styles.heading} mb-1 font-bold`}>{inning?.map((i) => i?.nInningNumber === data?.nInningNumber && i?.sShortName)} : {data?.sScore}</p>
            <div className={styles.orangeText}>End of Over {+data?.sOver}</div>
          </div>
        </div>

        <div className={width > 767 ? styles.dContents : 'd-flex w-100 justify-content-center'}>
          {data?.aBatters?.length !== 0 &&
            <>
              {width > 767 && (
                <div className={styles.divider}></div>
              )}
              <div className={`${styles.info} ${styles.partners} ${width > 767 && 'text-center'} ${width < 767 && 'text-md-end'}`}>
                {data?.aBatters?.map((bat, index) => {
                  const oBatter = players[bat?.iBatterId] || bat?.oBatter
                  return (
                    <p className={`${styles.headingSmall} m-0`} key={index}>
                      <span className='font-bold' >{oBatter?.eTagStatus === 'a' && oBatter?.oSeo?.sSlug ? (
                        <CustomLink href={`/${oBatter?.oSeo?.sSlug}`}>{bat?.oBatter?.sFullName || oBatter?.oPlayer?.sFullName || bat?.oBatter?.sShortName || oBatter?.oPlayer?.sShortName}</CustomLink>
                      ) : bat?.oBatter?.sFullName || oBatter?.oPlayer?.sFullName || bat?.oBatter?.sShortName || oBatter?.oPlayer?.sShortName}</span> <span className={`${styles.secondary} ms-2`}> {bat?.nRuns}({bat?.nBallFaced})</span>
                    </p>
                  )
                })}
              </div>
            </>
          }
          {/* {index !== data?.aBatters?.length - 1 && (
            <div className={styles.divider}></div>
          )} */}
          {
            data?.aBowlers.length !== 0 &&
            <>
              <div className={styles.divider}></div>
              <div className={`${styles.info} ${styles.headingSmall} text-center `}>
                <p className="mb-1 font-bold">
                  {oBowler?.eTagStatus === 'a' && oBowler?.oSeo?.sSlug ? (
                    <CustomLink href={`/${oBowler?.oSeo?.sSlug}`}>{data?.aBowlers[0]?.oBowler?.sFullName || oBowler?.oPlayer?.sFullName || data.aBowlers[0]?.oBowler?.sShortName || oBowler?.oPlayer?.sShortName}</CustomLink>
                  ) : data?.aBowlers[0]?.oBowler?.sFullName || oBowler?.oPlayer?.sFullName || data.aBowlers[0]?.oBowler?.sShortName || oBowler?.oPlayer?.sShortName}</p>
                <p className={`${styles.secondary} mb-0 `}>{data?.aBowlers[0]?.sOvers}-{data?.aBowlers[0]?.nMaidens}-{data?.aBowlers[0]?.nRunsConceded}-{data?.aBowlers[0]?.nWickets}
                </p>
              </div>
            </>
          }
        </div>
      </div>
    </>
  )
}

EndOverRC.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  inning: PropTypes.array,
  index: PropTypes.number,
  isFirst: PropTypes.bool
}

export default EndOverRC
